<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Rekap Piutang</h4>
                        <div class="form-inline">
                          <span><b>Company:</b></span>
                          <select v-model="company_no" class="form-control">
                            <option value="">-- All --</option>
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                          </select>
                          <span><b>Date:</b></span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshAll">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshPayment">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Payment
                          </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 150px">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <h5>Rekap Piutang <i><b>{{ monthNow }}</b></i></h5>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="table-responsive">
                      <table class="table table-item mb-0 table-sm table-striped table-hover">
                        <tr>
                          <td>Sisa Piutang <i><strong>per {{ monthBefore }}</strong></i></td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalOutstandingStatus === true"></span>
                            <span v-else>
                              <b>{{ totalOutstanding | currency }}</b>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Sales (Penjualan)</td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalSalesStatus === true"></span>
                            <span v-else>
                              <b>{{ totalSales | currency }}</b>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>Retur Jual</td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalReturStatus === true"></span>
                            <span v-else>
                              <b>({{ totalRetur | currency }})</b>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Penerimaan Pembayaran <i>Net (Tunai, Transfer, Giro Cair, Uang Muka)</i>
                          </td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <b>({{ totalFinishPayment | currency }})</b>
                              <!-- totalPaymentFinish -->
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="ml-3">Penerimaan</span>
                          </td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <i>{{ totalPaymentAll | currency }}</i>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="ml-3">Penerimaan Pembayaran Giro (Belum Cair)</span>
                          </td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <i>{{ totalPaymentGiroBelumCair | currency }}</i>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span class="ml-3">Pelunasan Penerimaan</span></td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <i>{{ totalPaymentFinish | currency }}</i>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="ml-3">Discount Penerimaan Pembayaran</span>
                          </td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <i>{{ totalPaymentDiscount | currency }}</i>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="ml-3">Rounding Penerimaan Pembayaran</span>
                          </td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <i>{{ totalPaymentRound | currency }}</i>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="ml-3">Uang Muka Penerimaan Pembayaran</span>
                          </td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.totalPaymentStatus === true"></span>
                            <span v-else>
                              <i>{{ totalPaymentUangMuka | currency }}</i>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="ml-5"><b>Sisa Piutang</b></span>
                          </td>
                          <!-- <td class="text-right"><b>{{ totalOutstanding + totalSales - totalRetur - totalPayment + totalPaymentGiro | currency }}</b></td> -->
                          <td class="text-right"><b>{{ totalOutstanding + totalSales - totalRetur - totalFinishPayment | currency }}</b></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>{{ dataPaymentFinish.length }}</div>
        <div>{{ totalPaymentFinish | currency }}</div>
        <div>{{ totalPayment + totalPaymentGiro | currency }}</div>
        <div>{{ totalPayment + totalPaymentGiro + totalPaymentFinish | currency }}</div>
        <p v-for="r in dataPaymentFinish" :key="r.id">
          <b>{{ r.group_no }}</b> - {{ r.payment_date | dateFormat('DD/MM/YYYY') }} - {{ r.finish_date | dateFormat('DD/MM/YYYY') }} - {{ r.total | currency }}
        </p>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { paymentUrl, returnUrl, salesUrl, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'SalesRekapPiutang',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    const firstDayYear = new Date(date.getFullYear(), 0, 1)
    return {
      startDate: [date1, date2],
      area: '',
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: firstDayYear.toISOString(),
      date2: new Date().toISOString(),
      typeData: null,
      period: [],
      dataRaw: [],
      dataRaw2: [],
      dataRetur: [],
      dataPayment: [],
      dataPaymentFinish: [],
      dataSales: [],
      monthNames: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'Desember'],
      totalOutstanding: 0,
      totalOutstandingStatus: false,
      totalReturStatus: false,
      totalPaymentStatus: false,
      totalSalesStatus: false,
      status: 'outstanding',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    totalFinishPayment () {
      var sum = 0
      sum = this.totalPaymentAll + this.totalPaymentDiscount + this.totalPaymentRound - this.totalPaymentUangMuka - this.totalPaymentGiroBelumCair
      return sum
    },
    totalPaymentUangMuka () {
      var sum = 0
      var array = this.dataPayment
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 4) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalSales () {
      var array = this.dataSales
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    monthNow () {
      var month = '01'
      month = (this.startDate[1].getMonth())
      return this.monthNames[month] + ' ' + this.startDate[1].getFullYear()
    },
    monthBefore () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var newBegin = new Date(begin)
      newBegin.setDate(newBegin.getDate() - 1)
      return newBegin.getDate() + ' ' + this.monthNames[newBegin.getMonth()] + ' ' + newBegin.getFullYear()
    },
    totalPaymentAll () {
      var sum = 0
      var array = this.dataPayment
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPayment () {
      var array = this.dataPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id !== 3) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    totalPaymentFinish () {
      var array = this.dataPaymentFinish
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPaymentGiro () {
      var array = this.dataPayment
      var sum = 0
      var dateNow = new Date(this.startDate[1]).getTime()
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 3) {
          var finishDate = new Date(array[i].finish_date).getTime()
          if (finishDate <= dateNow) {
            sum += parseFloat(array[i].total)
          }
        }
      }
      return sum
    },
    totalPaymentGiroBelumCair () {
      var array = this.dataPayment
      var sum = 0
      var dateNow = new Date(this.startDate[1]).getTime()
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 3) {
          var finishDate = new Date(array[i].finish_date).getTime()
          if (finishDate > dateNow) {
            sum += parseFloat(array[i].total)
          }
        }
      }
      return sum
    },
    totalPaymentDiscount () {
      var array = this.dataPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount)
      }
      return sum
    },
    totalPaymentRound () {
      var array = this.dataPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var round = parseFloat(array[i].round)
        if (isNaN(round)) {
          sum += 0
        } else {
          if (round < 0) {
            sum += Math.abs(round)
          } else {
            sum += 0 - round
          }
        }
      }
      return sum
    },
    totalRetur () {
      var array = this.dataRetur
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    async refreshAll () {
      this.totalOutstandingStatus = true
      this.totalSalesStatus = true
      this.totalReturStatus = true
      this.totalPaymentStatus = true
      await this.refreshPiutang()
      await this.refreshSales()
      await this.refreshRetur()
      await this.refreshPayment()
    },
    async refreshSales () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = salesUrl + '?begin=' + begin + '&end=' + end + '&company=' + this.company_no
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataSales = response.data.data
          this.totalSalesStatus = false
        })
        .catch(error => {
          this.totalSalesStatus = false
          console.log(error)
          console.log(error.response)
          this.$swal('Sales', error.response.data.message, 'error')
          throw error
        })
    },
    async refreshPiutang () {
      this.totalOutstanding = 0
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      var newBegin = new Date(begin)
      newBegin.setDate(newBegin.getDate() - 1)
      var obj = {
        begin: '2022-01-01',
        end: newBegin.getFullYear() + '-' + (newBegin.getMonth() + 1) + '-' + newBegin.getDate(),
        company_no: this.company_no,
        term: '0'
      }
      await axios.post(salesUrl + '/rekap-piutang', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.totalOutstanding = response.data.outstanding
          console.log(response.data.message)
          this.totalOutstandingStatus = false
        })
        .catch(error => {
          this.totalOutstandingStatus = true
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async refreshRetur () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      const company = this.company_no
      await axios.get(returnUrl + '?begin=' + begin + '&end=' + end + '&type=sales&company=' + company, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRetur = response.data.data
          this.totalReturStatus = false
        })
        .catch(error => {
          this.totalReturStatus = true
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async refreshPayment () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = paymentUrl + '?&begin=' + begin + '&end=' + end + '&category=sales&company=' + this.company_no
      console.log(url)
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          this.dataPayment = response.data.data
          this.totalPaymentStatus = false
        })
        .catch(error => {
          this.totalPaymentStatus = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.refreshPaymentFinish()
    },
    async refreshPaymentFinish () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        category: 'sales',
        company: this.company_no
      }
      await axios.post(paymentUrl + '/list-finish-date', obj, { headers: getHeader() })
        .then(response => {
          this.dataPaymentFinish = response.data.data
          this.totalPaymentStatus = false
        })
        .catch(error => {
          this.totalPaymentStatus = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style scoped>
.header-period {
  background-color: #6FB56F;
  color: white;
}
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
